// -----------------------------------------------------------------------------
// Scripts for inquiry form
// -----------------------------------------------------------------------------

function inquiryForm() {
  // Name trip
  var tripName = $(".inquiry-form__trip-name").text();
  var inputTrip = $(".inquiry-form__trip-name-value");

  setTimeout(function(){
    inputTrip.val(tripName);
  }, 500);

  // Other accomodation
  var otherAccomodation = $(".accommodation-wrapper").find(
    ".wpcf7-list-item.last .wpcf7-list-item-label"
  );
  otherAccomodation.on("click", function () {
    $(this).toggleClass("last-active");

    if (otherAccomodation.hasClass("last-active")) {
      $(".inquiry-form__your-accommodation").fadeIn("slow");
      $('input[name="your-accommodation"]').attr("readonly", false);
    } else {
      $(".inquiry-form__your-accommodation").fadeOut("slow");
      $('input[name="your-accommodation"]').attr("readonly", true);
      $('input[name="your-accommodation"]').val("");
    }
  });

  // Other travel
  var otherTravel = $(".travel-wrapper").find(
    ".wpcf7-list-item.last .wpcf7-list-item-label"
  );
  var travelOptions = $(".travel-wrapper").find(
    ".wpcf7-list-item:not(.last) .wpcf7-list-item-label"
  );
  otherTravel.on("click", function () {
    $(this).toggleClass("last-active");

    if (otherTravel.hasClass("last-active")) {
      $(".inquiry-form__your-custom-travel").fadeIn("slow");
      $('input[name="your-custom-travel"]').attr("readonly", false);
    } else {
      $(".inquiry-form__your-custom-travel").fadeOut("slow");
      $('input[name="your-custom-travel"]').attr("readonly", true);
      $('input[name="your-custom-travel"]').val("");
    }
  });

  travelOptions.on("click", function () {
    if (otherTravel.hasClass("last-active")) {
      otherTravel.removeClass("last-active");
      $(".inquiry-form__your-custom-travel").fadeOut("slow");
      $('input[name="your-custom-travel"]').attr("readonly", true);
      $('input[name="your-custom-travel"]').val("");
    }
  });

  // Other find
  var otherFind = $(".find-wrapper").find(
    ".wpcf7-list-item.last .wpcf7-list-item-label"
  );
  var findOptions = $(".find-wrapper").find(
    ".wpcf7-list-item:not(.last) .wpcf7-list-item-label"
  );
  otherFind.on("click", function () {
    $(this).toggleClass("last-active");

    if (otherFind.hasClass("last-active")) {
      $(".inquiry-form__your-find").fadeIn("slow");
      $('input[name="your-find"]').attr("readonly", false);
    } else {
      $(".inquiry-form__your-find").fadeOut("slow");
      $('input[name="your-find"]').attr("readonly", true);
      $('input[name="your-find"]').val("");
    }
  });

  findOptions.on("click", function () {
    if (otherFind.hasClass("last-active")) {
      otherFind.removeClass("last-active");
      $(".inquiry-form__your-find").fadeOut("slow");
      $('input[name="your-find"]').attr("readonly", true);
      $('input[name="your-find"]').val("");
    }
  });

  // Limit the min/max input values
  $(
    'input[name="trip-age-to"], input[name="trip-age-from"], input[name="trip-persons"], input[name="room-single"], input[name="room-double"], input[name="room-twin"], input[name="room-triple"], input[name="room-multi"]'
  ).change(function () {
    var max = parseInt($(this).attr("max"));
    var min = parseInt($(this).attr("min"));
    if ($(this).val() > max) {
      $(this).val(max);
    } else if ($(this).val() < min) {
      $(this).val(min);
    }
  });

  // Arrival date cannot be greater than departure date
  $('input[name="trip-arrival"], input[name="trip-departure"]').change(
    function () {
      var arrival = $('input[name="trip-arrival"]');
      var departure = $('input[name="trip-departure"]');

      if (arrival.val() && departure.val() && arrival.val() > departure.val()) {
        departure.val(arrival.val());
      }
    }
  );

  $("input[name='trip-departure'], input[name='trip-arrival']").on('focus', function() {
    $(this).attr('placeholder', "DD/MM/YYYY");
  })

  // Age from cannot be grater than age Up to
  $('input[name="trip-age-from"], input[name="trip-age-to"]').change(
    function () {
      var from = $('input[name="trip-age-from"]');
      var to = $('input[name="trip-age-to"]');

      if (from.val() > 0 && to.val() > 0 && from.val() > to.val()) {
        to.val(from.val());
      }
    }
  );

  // Datepicker init
  $(function () {
    var dateFormat = "dd/mm/yy",
      from = $("input[name='trip-arrival']")
        .datepicker({
          defaultDate: "+1d",
          dateFormat: "dd/mm/yy",
          showButtonPanel: true,
          minDate: 0,
        })
        .on("change", function () {
          to.datepicker("option", "minDate", getDate(this));
        }),
        to = $("input[name='trip-departure']")
        .datepicker({
          defaultDate: "+1d",
          dateFormat: "dd/mm/yy",
          showButtonPanel: true,
          minDate: 0,
        })
        .on("change", function () {
          from.datepicker("option", "maxDate", getDate(this));
        });

    function getDate(element) {
      var date;
      try {
        date = $.datepicker.parseDate(dateFormat, element.value);
      } catch (error) {
        date = null;
      }

      return date;
    }
  });

  $("body").on("wpcf7mailsent", function () {
    var tripName = $(".inquiry-form__trip-name").text();
    var inputTrip = $(".inquiry-form__trip-name-value");
    inputTrip.val(tripName);
  });

  document.addEventListener(
    "wpcf7mailsent",
    function (event) {
      if (otherFind.hasClass("last-active")) {
        otherFind.removeClass("last-active");
        $(".inquiry-form__your-find").fadeOut("slow");
        $('input[name="your-find"]').attr("readonly", true);
        $('input[name="your-find"]').val("");
      }

      if (otherTravel.hasClass("last-active")) {
        otherTravel.removeClass("last-active");
        $(".inquiry-form__your-custom-travel").fadeOut("slow");
        $('input[name="your-custom-travel"]').attr("readonly", true);
        $('input[name="your-custom-travel"]').val("");
      }
    },
    false
  );
}
